import React, { useState, useRef, useEffect } from "react";
import {
  Paper,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Grid,
  Checkbox,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  FormControl,
  MenuItem,
  IconButton,
  InputLabel,
  Autocomplete,
  CircularProgress,
  InputAdornment,
  Radio,
  Select,
  RadioGroup,
} from "@material-ui/core";
import { Delete } from "@mui/icons-material";

import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  successColor,
  tooltip,
  cardTitle,
  grayColor,
  defaultFont,
  blackColor,
} from "../../../StyledComponents/material-dashboard-pro-react";
import { ArrowBack } from "@mui/icons-material";

import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { formatDateTimeForBackend } from "../../../Functions";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import UsersByRoleMulti from "../NewInvoice/Dropdowns/UsersByRoleMulti";
import GeneralSetting from "./GeneralSetting";
import SignatorySetting from "./Signatory/SignatorySetting";
import InvoiceTypeSetting from "./InvoiceType/InvoiceType";
import LoamApproverSetting from "./LoamApprover/loamApproverSetting";
import SG_PM_TT_PTSetting from "./SG_PM_TT_PT/SG_PM_TT_PTSetting";
import TreasurySetting from "./Treasury/TreasurySetting";
import PCDVSegmentsSetting from "./PCDVSegments/PCDVSegmentsSettings";
import VendorAccessSetting from "../VendorAccess/vendorAccessSetting";
import StampDutySetting from "../StampDuty/StampDutySetting";
// import { MenuProps } from "react-select/dist/declarations/src";
const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const AdminSetting = () => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState("General Settings");
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [formState, setFormState] = useState({
    old_SessionTimeOut: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_SkipIPAddress: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_EnableAuditAccessLog: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_PromptLogin: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_LOAMSection: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_TwoFactorAuthEnabled: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_SODReviewer: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_ManagerTreasury: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_VFPaymentProcessor: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    old_APSupervisor: "",
    old_APManager: "",
    old_APGM: "",
    old_APDirector: "",
    old_LOAMSectionList: [
      // {
      //   id: 0,
      //   parent_ID: 0,
      //   expenseTypeName: "string",
      //   description: "string",
      //   code: "string",
      //   isDD: true,
      //   activeInd: true,
      //   sectionLevel: 0,
      //   isValidAuthority: true,
      //   isTravel: true,
      //   travelTypeId: "string",
      //   validAuthority: "string",
      //   active: "string",
      //   isAgreementTemplate: true,
      //   mpdAgreementTemplateID: "string",
      // },
    ],
    sessionTimeOut: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    skipIPAddress: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    enableAuditAccessLog: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    promptLogin: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    loamSection: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    twoFactorAuthEnabled: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    sodReviewer: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    managerTreasury: [],
    vfPaymentProcessor: [
      // {
      //   referenceId: 0,
      //   referenceKey: "string",
      //   referenceCode: "string",
      //   referenceText: "string",
      //   referenceProp1: "string",
      //   referenceProp2: "string",
      //   referenceProp3: "string",
      //   referenceProp4: "string",
      //   isActive: true,
      // },
    ],
    apSupervisor: "",
    apManager: "",
    apgm: "",
    apDirector: "",
    loamSectionList: [
      // {
      //   id: 0,
      //   parent_ID: 0,
      //   expenseTypeName: "string",
      //   description: "string",
      //   code: "string",
      //   isDD: true,
      //   activeInd: true,
      //   sectionLevel: 0,
      //   isValidAuthority: true,
      //   isTravel: true,
      //   travelTypeId: "string",
      //   validAuthority: "string",
      //   active: "string",
      //   isAgreementTemplate: true,
      //   mpdAgreementTemplateID: "string",
      // },
    ],
  });
  // const [attachmentLoader, setAttchmentLoader] = useState(false);
  let AdminSettings = [
    { label: "General Settings", value: "General Settings" },
    { label: "Invoice Type", value: "InvoiceType" },
    { label: "Groups", value: "Groups" },
    { label: "Signatory", value: "Signatory" },
    { label: "LOAM Approver", value: "LoamApprover" },
    { label: "PCDV Segments", value: "PCDVSegments" },
    { label: "Treasury", value: "Treasury" },
    { label: "Posting Logs", value: "PostingLogs" },
    { label: "SGLInd", value: "SGLInd" },
    { label: "Payment Method", value: "PaymentMethod" },
    { label: "TType", value: "TType" },
    { label: "Posting Key", value: "PostingKey" },
    { label: "Report", value: "Report" },
    { label: "Payment Term", value: "PaymentTerm" },
    { label: "TCode Acess", value: "TCodeAcess" },
    { label: "Supervisor Level", value: "SupervisorLevel" },
    { label: "Vendor Access", value: "VendorAccess" },
    { label: "Stamp Duty", value: "StampDuty" },
  ];
  useEffect(() => {

  }, [formState])
  const saveData = (value) => {
    const axios = require("axios");
    let data = JSON.stringify([value]);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/SaveGeneralInfo`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {

      })
      .catch((error) => {

      });
  };

  return (
    <Card style={{ marginLeft: "20px" }}>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "1px 27px",
            backgroundColor: "#031C30",
            color: "white",
            height: "62px",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <h4>I2P Administration</h4>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form>
          <Grid container mt={1} spacing={2}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Typography>Admin Item</Typography>
              <FormControl fullWidth size="small">
                <Select
                  displayEmpty
                  value={admin}
                  onChange={(event) => {
                    // setuserRole(event.target.value);

                    const {
                      target: { value },
                    } = event;

                    setAdmin(value);
                  }}
                  style={{ height: 30 }}
                  MenuProps={MenuProps}
                >
                  {AdminSettings.map((item) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}

                  {admin == "" ? (
                    <>
                      <Typography variant="h6" component="h6" color="error">
                        user role is required
                      </Typography>
                    </>
                  ) : null}
                </Select>
              </FormControl>
            </Grid>
            {admin == "General Settings" && (
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{ padding: "9px", marginTop: "20px", height: 30 }}
                  p={4}
                  onClick={() => {
                    saveData(formState);
                  }}
                >
                  Send
                </Button>
              </Grid>

            )}
            {/* {(admin === "PaymentMethod" || admin==="SGLInd" || admin==="TType")&&
             (invoiceLoader ?
  
            <Grid item xs={12} sm={12} md={2} lg={2}mt ={2}>
              <CircularProgress color="info" /> 
              </Grid>: null
             )
            }*/}

          </Grid>
          <>
            {admin == "General Settings" && (
              <GeneralSetting
                formState={formState}
                setFormState={setFormState}
                saveData={saveData}
              />
            )}

          </>
        </form>
        {admin == "Signatory" && (
          <SignatorySetting />
        )}
        {admin == "InvoiceType" && (
          <InvoiceTypeSetting
            PageFor={admin}
          />

        )


        }
        {admin == "LoamApprover" && (
          <LoamApproverSetting />


        )
        }
         {admin == "VendorAccess" && (
          <VendorAccessSetting />

        )
        }
       {admin == "StampDuty" && (
          <StampDutySetting />


        )
        }
        {admin === "PCDVSegments" && (
          <PCDVSegmentsSetting />
        )}
        {(admin === "PaymentMethod") &&
          <SG_PM_TT_PTSetting
            refKey={admin}
            invoiceLoader={invoiceLoader}
            setInvoiceLoader={setInvoiceLoader}
          />
        }
        {(admin === "SGLInd") &&
          <SG_PM_TT_PTSetting
            refKey={admin}
            invoiceLoader={invoiceLoader}
            setInvoiceLoader={setInvoiceLoader}
          />
        }
        {(admin === "TType") &&
          <SG_PM_TT_PTSetting
            refKey={admin}
            invoiceLoader={invoiceLoader}
            setInvoiceLoader={setInvoiceLoader}
          />
        }
        {(admin === "PaymentTerm") &&
          <SG_PM_TT_PTSetting
            refKey={admin}
            invoiceLoader={invoiceLoader}
            setInvoiceLoader={setInvoiceLoader}
          />
        }
        {
          (admin === "SupervisorLevel") &&
          <SG_PM_TT_PTSetting
            refKey={admin}
            invoiceLoader={invoiceLoader}
            setInvoiceLoader={setInvoiceLoader}
          />
        }
        {(admin === "PostingKey") &&
          <SG_PM_TT_PTSetting
            refKey={admin}
            invoiceLoader={invoiceLoader}
            setInvoiceLoader={setInvoiceLoader}
          />

        }
        {(admin === "Treasury") &&
          <TreasurySetting />
        }
      </CardBody>
    </Card>
  );
};

export default AdminSetting;
